/*
 * Where: src/pages/IndexPage.js
 * What: Top page component (index.html route).
 * Why: Render service introduction as the primary landing page.
 */
import React from 'react';
import { INTRO_FLOW, TOP_HERO, VALUE_POINTS } from '../constants/topPageContent';
import ServiceHeroSection from '../features/top/components/ServiceHeroSection';
import SupportPreviewSection from '../features/top/components/SupportPreviewSection';

function IndexPage() {
    return (
        <>
            <ServiceHeroSection hero={TOP_HERO} />
            <SupportPreviewSection valuePoints={VALUE_POINTS} introFlow={INTRO_FLOW} />
        </>
    );
}

export default IndexPage;
